import React, { useMemo, memo } from 'react';
import { ProgressCard as ProgressCardType } from './types';
import { DefaultProgressCard } from './DefaultProgressCard';
import { GenerateProgressCard } from './GenerateProgressCard';
import { ProgressCard } from './ProgressCard';
import { CanvasSkeleton } from './CanvasSkeleton';
import { Box } from '@mui/material';
import styled from 'styled-components';

const ProgressCardContainer = styled(Box)(({ theme }) => ({
    padding: '20px 20px 20px 0',
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    boxSizing: 'border-box',
}));

export const Canvas = memo(({isLoading, details}: {isLoading?: boolean, details: ProgressCardType[]}) => {
    // Show skeleton when loading
    if (isLoading) {
        return <CanvasSkeleton />;
    }

    // Memoize sorted details to prevent re-sorting on every render
    const sortedDetails = useMemo(() => {
        return [...details].sort((a, b) => (a.display_order || 0) - (b.display_order || 0));
    }, [details]);

    return <ProgressCardContainer>
        {sortedDetails.map((card, index) => (
            <ProgressCard 
                type={card.type}
                key={`${card.title || 'card'}-${index}`} 
                card={card} 
            />
        ))}
    </ProgressCardContainer>
});

// Add display name for debugging
Canvas.displayName = 'Canvas';

// Export individual components
export { ProgressCard, DefaultProgressCard, GenerateProgressCard };